import { Container, Image, MantineSize } from "@mantine/core";
import { ReactNode, useEffect } from "react";

export default function BaseTemplate({
  src,
  size,
  disableContainer,
  centered,
  backgroundColor,
  children,
}: {
  src?: string;
  size?: MantineSize;
  disableContainer?: boolean;
  centered?: boolean;
  backgroundColor?: string;
  children: ReactNode;
}) {
  const slideHeight = "100%";

  useEffect(() => {
    if (backgroundColor) {
      document.body.style.backgroundColor = backgroundColor;
    }
  }, [backgroundColor]);

  return (
    <>
      {src && (
        <Image
          src={src ?? "/"}
          alt=""
          h={slideHeight}
          opacity={0.4}
          m={-16}
          w="100%"
          pos="absolute"
          style={{ zIndex: -1 }}
          fit="inherit"
        />
      )}
      {disableContainer && children}
      {!disableContainer && (
        <Container
          size={size}
          py={{ base: "6vh", sm: "14vh" }}
          style={{
            display: centered ? "flex" : "",
            justifyContent: "center",
            alignItems: centered ? "center" : "start",
            minHeight: "calc(100dvh - 160px)",
          }}
        >
          {children}
        </Container>
      )}
    </>
  );
}
